import { memo, FC } from 'react';

import VSpacing from 'bloko/blocks/vSpacing';

import PeriodInDays, { PeriodVariants } from 'src/components/Price/PeriodInDays';
import PriceCartItemZP from 'src/components/Price/PriceCart/PriceCartItemZP';
import ActivationDate from 'src/components/Price/PriceCart/PriceCartProduct/ActivationDate';
import RegionAndProfArea from 'src/components/Price/PriceCart/PriceCartProduct/RegionAndProfArea';
import { ZpCartProductProps } from 'src/models/price/priceCart';

const ZpBranding: FC<ZpCartProductProps> = ({ product, translations }) => {
    return (
        <PriceCartItemZP
            dataQa={`cart-item__tariff-${product.tariff}`}
            product={product}
            title={translations.tariffTitle[product.tariff]}
        >
            <RegionAndProfArea product={product} />
            <VSpacing base={1} />
            <PeriodInDays period={product.period} variant={PeriodVariants.Option} />
            <VSpacing base={1} />
            <ActivationDate product={product} />
        </PriceCartItemZP>
    );
};

export default memo(ZpBranding);
